import React, { createContext, useContext, useMemo, useState } from "react"

export type ContextProps = {
  pronto: any
  setPronto: any
}

export const ProntoContext = createContext<ContextProps | undefined>(undefined)

export const ProntoProvider: React.FC = ({ children }) => {
  const [pronto, setPronto] = useState([])
  const contextValue = useMemo<ContextProps>(
    () => ({
      pronto,
      setPronto,
    }),
    [pronto, setPronto]
  )
  return <ProntoContext.Provider value={contextValue}>{children}</ProntoContext.Provider>
}

export const useProntoContext = (): ContextProps => ({ ...useContext(ProntoContext) } as ContextProps)